import { setMGI18n, type MGKey } from '@mg/ui/i18n';

const ENGLISH: Partial<Record<MGKey, string>> = {
  btn_cancel: 'Cancel',
  btn_close: 'Close',
  btn_confirm: 'Confirm',
  btn_reload: 'Reload',
  btn_reset_columns_to_default: 'Reset to default',
  btn_retry: 'Try again',
  btn_show_less_text: 'Show less',
  btn_show_more_text: 'Show more',
  err_unknown_error_message: 'Something went wrong. Please try again.',
  lbl_close_modal: 'Close dialog',
  lbl_new: 'New',
  lbl_no_options: 'No options',
  lbl_row_number: 'Row',
  no_data_available: 'No data',
  no_data_available_for_this_filter: 'Nothing matches this filter',
  oops_something_went_wrong: 'Something went wrong.',
  plh_search: 'Search…',
  tlt_actions: 'Actions',
  tlt_adjust_columns: 'Adjust columns',
  tlt_filter: 'Filter',
  tlt_no_actions_available: 'No actions available',
  tlt_no_more_filter_available: 'No filters available for this table.',
  tlt_select_at_least_one_row: 'Select at least one row to run an action.',
  txt_app_update_available: 'A new version of this page is available',
};

/** @mg/ui ships German defaults; this app is English. Keys not listed here fall back to the German. */
export function installEnglishForMGUI(): void {
  setMGI18n({ t: (key) => ENGLISH[key] });
}
